import get from 'lodash/get'
import settings from '../../settings'
import ensureSlash from './ensureSlash'

const getSuccessEndpoint = (successUrl = get(settings, 'uploads.successUrl')) =>
  successUrl != null ? ensureSlash(successUrl) : successUrl

export default getSuccessEndpoint
